<template>
  <div class="chart-wrapper">
    <div class="chart-header">
      <div class="title">
        <span>{{ title }}</span>
        <img
          @click="showBody"
          src="../assets/Icon/Arrow/Down.svg"
          :style="showCharts ? 'transform: rotate(180deg);' : ''"
          alt
          :data-id="subTilite"
        />
      </div>
      <div class="sub-title">{{ subTilite }}</div>
    </div>
    <slot v-if="showBody" />
  </div>
</template>

<script>
import { find } from "highcharts";
export default {
  components: {
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
  },
  props: ["title", "subTilite"],
  data: () => ({
    showCharts: false,
  }),
  methods: {
    showBody(e) {
      let dataId = $(e.target).attr("data-id");
      if (this.showCharts) {
        this.showCharts = false;
      } else {
        this.showCharts = true;
      }
      this.$emit("clicked", [this.showCharts, dataId]);
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-wrapper {
  height: fit-content !important;
  box-sizing: border-box;
  padding: 15px 15px 15px 15px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  color: #000000;
  font-family: "Helvetica Neue";
  font-size: 18px;
  font-weight: 500;
  line-height: 30px;
  width: 100%;

  .chart-header {
    .title {
      width: 100%;
      height: 30px;
      margin-bottom: 10px;
      align-items: center;
      img {
        cursor: pointer;
        float: right;
        margin: 5px 0;
      }
      .select-delay {
        width: 200px;
        float: right;
        margin-right: 20px;
      }
    }
    .sub-title {
      font-family: "Helvetica Neue";
      text-align: center;
      color: grey;
      font-weight: 700;
      font-size: 14px;
    }
  }
}
</style>